import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { UserResourceService } from '@shared/resources/user-resource.service';

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const userResourceService = inject(UserResourceService);

  if (userResourceService.user.hasValue()) {
    const lang = userResourceService.user.value()!.language;
    const acceptLanguage = buildAcceptLanguage(lang);

    const modified = req.clone({
      setHeaders: {
        'Accept-Language': acceptLanguage,
      },
    });

    return next(modified);
  }

  return next(req);
};

/**
 * Maps user language codes ("de" | "en") to full BCP 47 tags.
 * Falls back to en-US if unknown.
 */
export function buildAcceptLanguage(userLang: string): string {
  const langMap: Record<string, string> = {
    de: 'de-DE',
    en: 'en-US',
  };

  // Pick mapped language or use browser language or fallback to en-US
  const primary = langMap[userLang] || navigator.language || 'en-US';

  // Add fallback order (e.g. "de-DE,de;q=0.9,en-US;q=0.8,en;q=0.7")
  const base = primary.split('-')[0];
  return `${primary},${base};q=0.9,en-US;q=0.8,en;q=0.7`;
}
